import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { exhibitActions, exhibitsActions } from './exhibits.actions';
import { ExhibitDto, exhibitInit } from './exhibits.dtos';

const exhibitReducer = combineReducers({
    list: createReducer<ExhibitDto[]>([] as ExhibitDto[])
      .handleAction(
        [
          exhibitsActions.success,
        ], (state, action) => action.payload),
  
    exhibit: createReducer<ExhibitDto>(exhibitInit)
      .handleAction(
        [
          exhibitActions.success,
        ], (state, action) => action.payload),
  
  });
  
  
  export default exhibitReducer;